import { useState } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export default function SetPassword({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 10) {
      setError("Password must be at least 10 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/set-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Failed to set password.");
      } else {
        setSuccess(`Password set. Log in as ${data.username}.`);
      }
    } catch {
      setError("Network error.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%", padding: "10px 12px", background: "var(--bg2)",
    border: "1px solid var(--border2)", borderRadius: 8,
    color: "var(--t1)", fontSize: 13, outline: "none", boxSizing: "border-box",
  };

  return (
    <div style={{
      minHeight: "100vh", background: "var(--bg)",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "var(--bg2)", border: "1px solid var(--border)",
        borderRadius: 14, padding: "36px 32px", width: 360,
      }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "var(--t1)", marginBottom: 6 }}>
          Set your password
        </div>
        <div style={{ fontSize: 13, color: "var(--t3)", marginBottom: 24 }}>
          Choose a password to activate your account.
        </div>
        {success ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ color: "var(--amber)", fontSize: 14, marginBottom: 16 }}>{success}</div>
            <button
              onClick={onDone}
              style={{
                width: "100%", padding: "11px", background: "var(--amber-bg)",
                border: "1px solid var(--amber-bdr)", borderRadius: 8,
                color: "var(--amber)", fontSize: 13, fontWeight: 700, cursor: "pointer",
              }}
            >
              Go to login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "var(--t3)", textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>
                Password
              </label>
              <input
                type="password"
                style={inputStyle}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div style={{ marginBottom: 18 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "var(--t3)", textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>
                Confirm Password
              </label>
              <input
                type="password"
                style={inputStyle}
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>
            {error && (
              <div style={{ color: "var(--red)", fontSize: 12, marginBottom: 12 }}>{error}</div>
            )}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%", padding: "11px", background: "var(--amber-bg)",
                border: "1px solid var(--amber-bdr)", borderRadius: 8,
                color: "var(--amber)", fontSize: 13, fontWeight: 700, cursor: "pointer",
              }}
            >
              {loading ? "Setting…" : "Set Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
